// extracted by mini-css-extract-plugin
export default {"general":"BorderBottom_general--v9Q"};